import { http } from '@/utils'
import type {
  IChartItem,
  IFundMyRes,
  IFundParam,
  IFundRes,
  IInviteRes,
  IMtVariety,
  IMyProfitParam,
  INotice,
  INoticeInfoRes,
  ISymbolList,
  IVarietyParam,
} from './types'
import type { AxiosResponse } from 'axios'

//获取通知
export const getNotice = (data: INotice) => {
  return http.post('/api/article/index', data)
}

// 获取资金统计
export const getFund = (data: IFundParam): Promise<AxiosResponse<IFundRes>['data']> => {
  return http.post('/api/report/my_funds_report', data)
}

// 获取我的资金
export const getFundMy = (): Promise<AxiosResponse<IFundMyRes>['data']> => {
  return http.post('/api/report/my_wallet_report')
}

// 仪表盘-我的mt盈利曲线（日和小时）
export const getFundMyProfit = (
  data: IMyProfitParam,
): Promise<AxiosResponse<IChartItem[]>['data']> => {
  return http.post('/api/report/my_mt_profit_report', data)
}

// 仪表盘-我的mt持仓净值曲线（日和小时）
export const getFundMyPosition = (
  data: IMyProfitParam,
): Promise<AxiosResponse<IChartItem[]>['data']> => {
  return http.post('/api/report/my_mt_equity_report', data)
}

//仪表盘-我的mt品种列表
export const getFundMyVariety = (
  data: IVarietyParam,
): Promise<AxiosResponse<ISymbolList[]>['data']> => {
  return http.post('/api/report/my_mt_symbol_list_report', data)
}

//仪表盘-我的mt详情报表
export const getFundMyDetail = (
  data: IVarietyParam,
): Promise<AxiosResponse<IMtVariety>['data']> => {
  return http.post('/api/report/my_mt_analysis_report', data)
}

//邀请客户
export const inviteCustomer = (data?: {
  server_id: string
}): Promise<AxiosResponse<IInviteRes>['data']> => {
  return http.post('/api/member/get_invite_url', data)
}

//获取安全保障等重要提示信息
export const getNoticeInfo = (): Promise<AxiosResponse<INoticeInfoRes>['data']> => {
  return http.post('/api/member/safety_guarantee_tip_info')
}
